﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("attachmentGallery", {
            bindings: {
                modalTitle: "@",
                items: "<",
                onSelect: "&",
                onDelete: "&",
                okTitle: "@",
                deleteTitle: "@"
            },
            templateUrl: ['version', function (version) {
                return `/js/components/attachmentGallery/attachmentGallery.html?v=${version}`
            }],
            controller: AttachmentGalleryController,
            controllerAs: "vm"
        });

    AttachmentGalleryController.$inject = ["$scope", "$rootScope", "$location", "$http", "$timeout", "$q"];

    function AttachmentGalleryController($scope, $rootScope, $location, $http, $timeout, $q) {
        var vm = this,
            previousItem;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.selected;

        vm.highlightItem = highlightItem;
        vm.selectItem = selectItem;
        vm.deleteItem = deleteItem;

        function onInit() {
            vm.obj = vm;
        }

        function onChanges(changes) {
            if (changes["items"] && vm.items !== undefined) {
                $("#attachment-gallery").modal({ backdrop: false });
            }
        }

        function highlightItem(item) {
            if (vm.selected) {
                vm.selected.__selected = false;
            }

            item.__selected = true;
            vm.selected = item;
        }

        function selectItem() {
            vm.onSelect({ "item": vm.selected });
        }

        function deleteItem() {
            vm.onDelete({ "item": vm.selected });
        }
    }

})();